import React, { useState } from "react";
import './App.css'; // Import your custom CSS

// Import components
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Test from "./Components/Test";
import Footer from "./Components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";

// Main App component
function App() {
  const [topic, setTopic] = useState(null); // Track current topic

  // Start quiz function (passed to Home)
  const startQuiz = (selectedTopic) => setTopic(selectedTopic);

  // Go back to Home function (passed to Test)
  const goBack = () => setTopic(null);

  return (
    // Root container: flex column, min height = 100vh
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar always visible */}
      <Navbar />

      {/* Main content: grows to fill remaining space */}
      <div className="flex-grow-1">
        {!topic ? (
          <Home startQuiz={startQuiz} />        // Show Home
        ) : (
          <Test topic={topic} goBack={goBack} /> // Show Quiz
        )}
      </div>

      {/* Footer: pushed to bottom automatically */}
      <Footer />
    </div>
  );
}

export default App;
